import { RequestTypes } from '../../../hooks/useRequest'

export const GENERATION_API_PREFIX = '/api/generators/v1/'
export const GENERATION_GRAPH_BLOCK = 'go-graphic'

export const postGraphData = {
    link: `${GENERATION_API_PREFIX}${GENERATION_GRAPH_BLOCK}`,
    method: RequestTypes.post,
}
